{
  "add_peer": "Добавить коллегу",
  "add_focus": "Добавить фокус",
  "add_specific_focus": "Добавьте фокус при необходимости...",
  "edit_focus": "Редактировать фокус",
  "edit_peers": "Редактировать коллег",
  "focus_from": "{name} попросил(а):",
  "add_reviewer_type": "Добавить тип рецензента",
  "add_review_type_workflow": "Добавить тип ревью",
  "add_rule": "Добавить правило",
  "additional_feedback": "Дополнительная обратная связь",
  "additional_feedback_choose_colleague": "Выбрать коллегу",
  "colleague_name": "Имя коллеги",
  "additional_feedback_search_colleague": "Найти коллегу",
  "additional_feedback_choose_where": "Выберите, где оставить фидбэк",
  "additional_feedback_choose_review_error": "Нужно выбрать в каком ревью оставить фидбэк",
  "additional_feedback_description": "Доступны только коллеги в активных циклах ревью",
  "additional_feedback_pre_title": "Хотите оставить дополнительный фидбэк?",
  "additional_feedback_title": "Выберите любого коллегу, участвующего в активном цикле ревью.",
  "ai_evaluating_description": "Обрабатываем отзывы и готовим для вас инсайты. Это может занять несколько минут.",
  "ai_evaluating_title": "ИИ анализирует отзывы",
  "ai_feature_description": "ИИ анализирует ответы на ревью и формирует ключевые выводы",
  "ai_feature_title": "Ревью ИИ",
  "ai_waiting_description": "Анализ начнется автоматически после того, как будет собрано достаточно отзывов.",
  "ai_waiting_title": "ИИ ждет завершения анализа",
  "all_questions": "Все вопросы",
  "no_answers_yet": "Ответов пока не было",
  "all_set_and_ready_description": "Приглашения будут отправлены, пользователи начнут отвечать",
  "all_set_and_ready_schedule_description": "Приглашения будут отправлены по расписанию",
  "all_set_and_ready_schedule_title": "Всё готово к запуску.\nЗапустить позже по расписанию?",
  "all_set_and_ready_title": "Всё готово к запуску.\nЗапустить ревью прямо сейчас?",
  "answer_anonymously": "Ответить анонимно",
  "app_notification_invite_peers_pre_title": "Выберите коллег, которые дадут вам обратную связь",
  "app_notification_invite_peers_pre_title_selected": "{title} запущен",
  "app_notification_invite_peers_title_selected": "Коллеги для обратной связи уже выбраны. При необходимости вы можете изменить список",
  "app_notification_invite_peers_title": "Они получат приглашение в рамках опроса",
  "app_notification_invited_respond_group_title": "{count, plural, =0{} one{} few{# человека ожидают вашей обратной связи} other{# человек ожидают вашей оценки}}",
  "app_notification_invited_respond_title": "Вас пригласили дать оценку о {type, select, myself {себе} manager {подчинённом} peer {коллеге} upward {руководителе} other {сотруднике}}",
  "auto_share_timing_after_end": "После завершения цикла",
  "auto_share_timing_immediately": "Сразу после заполнения",
  "average_score_based_on_responses": "Среднее значение {score} на основе {count, plural, one{# ответа} few{# ответов} many{# ответов} other{# ответов}}",
  "avg_by_all_reviewer_types": "Средняя по всем группам",
  "change_manager": "Поменять руководителя",
  "chart_performance_good": "Высокая эффективность",
  "chart_performance_lower": "Низкая эффективность",
  "chart_title_good_custom": "{title}: довольны",
  "chart_title_good_manager": "Менеджер доволен",
  "chart_title_good_peer": "Коллеги довольны",
  "chart_title_good_self": "Уверен в себе",
  "chart_title_good_upward": "Команда довольна",
  "chart_title_lower_custom": "{title}: менее довольны",
  "chart_title_lower_manager": "Менеджер менее доволен",
  "chart_title_lower_peer": "Коллеги менее довольны",
  "chart_title_lower_self": "Менее уверен в себе",
  "chart_title_lower_upward": "Команда менее довольна",
  "choose_form": "Выбрать форму",
  "choose_forms": "Выберите формы",
  "complete_review": "Завершить ревью",
  "complete_review_confirm": "После завершения вы получите финальную статистику, а сотрудники больше не смогут участвовать в ревью",
  "complete_review_question": "Вы хотите завершить ревью?",
  "configure_chart": "Настроить график",
  "configure_form_description": "Вы можете выбрать один из существующих шаблонов и отредактировать в нём вопросы конкретно для этого ревью или создать новый набор вопросов с нуля",
  "configure_forms": "Настройка форм",
  "configure_participants": "Настроить участников",
  "create_reviewer_type": "Создать новый тип",
  "create_performance_review": "Создать ревью",
  "create_review_template": "Создать шаблон",
  "do_not_use_emoji": "Не использовать эмодзи для этого ревью",
  "edit_review": "Изменить ревью",
  "employee_performance_empty_state_description": "Когда появятся завершённые ревью, вы увидите их здесь",
  "employee_performance_empty_state_title": "Ещё нет ревью",
  "empty_state_performance_review_templates_description": "Шаблоны помогают быстро настраивать ревью, используя готовые вопросы.\nНачните здесь, чтобы сэкономить время и придерживаться стандартов оценки в вашей компании.",
  "empty_state_performance_review_templates_title": "Создайте свой первый шаблон ревью",
  "feedback_evaluation": "Фидбек",
  "feedbacks_to_leave": "Ожидают обратной связи",
  "feedbacks_left": "Оставленные отзывы",
  "feedback_about_me": "Фидбэки обо мне",
  "feedback_ive_given": "Фидбэки, которые я дал",
  "feedbacks_left_empty_title": "Пока нет оставленных отзывов",
  "feedbacks_left_empty_description": "Здесь будут отображаться ваши завершенные отзывы",
  "final_score_breakdown": "Из чего состоит финальная оценка",
  "go_to_review": "Перейти к ревью",
  "goal_question_period_caption": "В ревью попадут только цели, у которых дата окончания попадает в этот период.",
  "goal_question_period_end": "Заканчивается по",
  "goal_question_period_start": "Заканчивается с",
  "goal_question_period_title": "Период окончания целей",
  "goal_question_show_when_no_goals": "Показывать вопрос, даже если нет активных целей",
  "goal_question_single_rating": "Оценивать все цели одной оценкой",
  "group": "Группа",
  "insights": "Аналитика",
  "invitation_description": "Напишите собственное письмо с приглашением участников пройти ревью.",
  "invitation_settings": "Настройка приглашений",
  "configure_invitations_by_reviewer_type": "Настроить приглашения по группам рецензентов",
  "invitation_mode_by_reviewer_type": "Разные приглашения для каждого типа ревьюера",
  "invitation_mode_by_reviewer_type_description": "Настройте независимые тему и текст для каждого типа ревьюера",
  "invitation_mode_common": "Одно приглашение для всех типов ревьюеров",
  "invitation_mode_common_description": "Используйте одинаковые тему и текст для всех ревьюеров",
  "variable_participant_full_name": "Полное имя участника",
  "invite_co_owners_description": "Они смогут изменять ревью так же, как и вы, за исключением приглашения других совладельцев",
  "invite_co_owners_title": "Пригласить совладельцев",
  "launch_on_schedule": "Запустить по расписанию",
  "launch_review": "Запустить ревью",
  "launch_review_confirm": "Вы уверены, что хотите запустить ревью?",
  "leave_feedback_about_your_work": "Оставьте обратную связь о вашей работе",
  "leave_performance_feedback": "Оставьте обратную связь о работе коллеги",
  "my_feedback": "Обратная связь",
  "my_reviews": "Мои ревью",
  "my_reviews_empty_description": "Здесь появятся сотрудники для ревью",
  "my_reviews_empty_title": "Нет сотрудников для ревью",
  "my_team_empty_description": "Здесь появятся результаты ревью вашей команды",
  "my_team_empty_title": "Для вашей команды нет результатов",
  "my_direct_reports_empty_description": "Как только ревью появятся, мы их покажем здесь",
  "my_direct_reports_empty_title": "Пока ещё нет ревью о ваших прямых подчинённых",
  "open_review": "Открыть ревью",
  "overall": "Суммарно",
  "overall_ratings": "Общие оценки",
  "overall_score": "Итоговая оценка",
  "pause_review": "Приостановить ревью",
  "performance": "Эффективность",
  "performance_review": "Ревью",
  "performance_review_notification_description": "Новые ревью для заполнения или доступные результаты",
  "performance_review_template": "Шаблон ревью",
  "performance_review_templates": "Шаблоны ревью",
  "performance_reviews": "Ревью",
  "performance_review_cycles": "Циклы ревью",
  "review_cycles": "Циклы ревью",
  "review_cycle": "Цикл ревью",
  "cycle_status": "Статус цикла",
  "feedback_on_my_direct_reports": "Фидбэк на моих прямых подчинённых",
  "feedback_on_my_subordinates": "Фидбэк на всех подчинённых",
  "reviews_completed_of": "{current} из {total} завершено",
  "new_review_cycle": "Новый цикл ревью",
  "performance_reviews_empty_state_description": "Узнайте, что действительно важно для вашей команды.\n Задайте правильные вопросы, получите честные ответы и сделайте работу лучше для всех.",
  "performance_reviews_empty_state_title": "Запустите первое ревью",
  "performance_reviews_empty_state_viewer_title": "Пока нет циклов ревью",
  "performance_reviews_empty_state_viewer_description": "Здесь будут отображаться доступные вам циклы ревью.",
  "performance_reviews_feature_description": "Проводите регулярное ревью, собирайте обратную связь и отслеживайте эффективность сотрудников",
  "performance_reviews_module": "Доступ к системе ревью",
  "performance_reviews_module_description": "Необходим для всех действий, связанных с ревью",
  "permissions_performance_review_templates_edit_description": "Создание, изменение и управление шаблонами ревью для организации",
  "permissions_performance_review_templates_none_description": "Нет возможности просматривать или использовать шаблоны ревью",
  "permissions_performance_review_templates_title": "Шаблоны ревью",
  "permissions_performance_review_templates_view_description": "Просмотр существующих шаблонов без возможности внесения изменений",
  "permissions_performance_reviews_create": "Создавать новые ревью",
  "permissions_performance_reviews_create_description": "Разрешить создавать ревью для сотрудников",
  "permissions_performance_reviews_manage_all": "Управлять существующими ревью",
  "permissions_performance_reviews_manage_all_description": "Редактировать, планировать или удалять любые ревью в системе",
  "personal_feedbacks": "Персональные отзывы",
  "no_goals_to_evaluate": "Нет целей для оценки",
  "question_type_goal": "Оценка целей",
  "question_type_goal_caption": "Оцените цели, которые заканчиваются в выбранном периоде",
  "rating": "Рейтинг",
  "ratings": "Рейтинги",
  "ratings_description": "Выберите вопросы, по которым будет проводиться оценка",
  "reopen_review": "Переоткрыть ревью",
  "reopen_review_confirm": "Ревью будет переоткрыто, и сотрудники смогут продолжить участие.",
  "reopen_review_question": "Вы хотите переоткрыть ревью?",
  "result_not_available_description": "Ревью анонимное. Чтобы сохранить конфиденциальность, результаты будут показаны, когда будет собрано достаточное количество ответов",
  "result_not_available_title": "Результаты пока недоступны",
  "resume_feedback": "Продолжить заполнение",
  "review_closed_description": "Это ревью больше не принимает ответы.",
  "responses_submitted_title": "Ваши ответы отправлены",
  "review_completed_description": "Спасибо за участие!",
  "review_completed_title": "Ревью завершено",
  "review_date_ends_at": "Дата окончания ревью",
  "review_has_been_updated_description": "Все изменения были успешно сохранены",
  "review_has_been_updated_title": "Ваше ревью было обновлено",
  "review_type": "Тип ревью",
  "review_type_custom": "Кастомная группа",
  "review_type_manager": "Оценка руководителя",
  "review_type_manager_short": "Руководитель",
  "review_type_peer": "Оценка коллег",
  "review_type_peer_description": "Выбор будет доступен после завершения настройки",
  "review_type_peer_short": "Коллеги",
  "review_type_self": "Самооценка",
  "review_type_self_short": "Самооценка",
  "review_type_upward": "Оценка подчиненных",
  "review_type_upward_short": "Подчиненные",
  "reviewee": "Оцениваемый",
  "reviewer_status_added": "Добавлен",
  "reviewer_status_completed": "Завершен",
  "reviewer_status_in_progress": "В процессе",
  "reviewer_status_invited": "Приглашен",
  "reviewer_type": "Тип рецензента",
  "reviewer_type_invitation": "Содержание приглашения",
  "reviewer_type_invitation_description": "Оставьте оба поля пустыми, чтобы использовать стандартный системный шаблон",
  "reviewers": "Рецензенты",
  "review_types": "Типы ревью",
  "manage": "Управление",
  "reviewers_description": "Какие типы оценок у вас будут?",
  "reviewers_settings": "Настройки",
  "reviewers_settings_description": "Давайте настроим параметры доступа и видимость",
  "reviews": "Опросы и ревью",
  "same_ratings_reviewer_types": "Одинаковые оценки для всех типов рецензентов",
  "score": "Оценка",
  "select_group": "Выбрать группу",
  "select_manager": "Выбрать руководителя",
  "select_peers": "Выбрать коллег",
  "select_template_description": "Используйте существующий шаблон или создайте новый для составления ревью",
  "select_template_title": "Выбрать шаблон ревью",
  "set_manager": "Назначенный руководитель",
  "settings_anonymity": "Анонимность",
  "settings_anonymous_threshold": "Количество ответов для раскрытия результатов",
  "settings_is_allow_manager_early_access": "Разрешить руководителю просматривать ревью до прохождения своей оценки",
  "settings_is_allow_manager_sharing": "Разрешить руководителю делиться ревью с оцениваемым участником",
  "settings_is_allow_edit_after_submit": "Разрешить менять ответы после отправки",
  "settings_is_allow_edit_after_submit_description": "Ревьюер может менять ответы, пока результатами не поделились с оцениваемым участником. Чтобы открыть правку после этого, нужно прекратить делиться результатами.",
  "settings_is_allow_to_invite": "Разрешить оцениваемому участнику приглашать коллег для оценки",
  "settings_is_allow_manager_to_invite": "Разрешить руководителю оцениваемого участника приглашать коллег для оценки",
  "settings_is_allow_feedback_from_anyone": "Разрешить сотрудникам вне этой группы присоединяться к ревью",
  "settings_is_allow_feedback_from_anyone_description": "Сотрудники смогут самостоятельно присоединяться к этой группе ревью и оставлять обратную связь",
  "settings_is_auto_share": "Автоматически делиться с оцениваемым участником",
  "settings_is_notify_owners_on_complete": "Уведомлять владельцев цикла после завершения ревью",
  "settings_make_anonymous": "Сделать анонимным",
  "setup_peers": "Назначить коллег",
  "setup_peers_in_custom": "Задать {name}",
  "share": "Поделиться",
  "share_all_feedback_description": "{name} увидит все доступные отзывы",
  "share_all_feedback_select_title": "Выберите, какие отзывы увидит {name}",
  "share_all_feedback_title": "Поделиться всеми отзывами",
  "share_feedbacks": "Поделиться отзывами",
  "shared": "Доступно",
  "skip_and_leave_as_draft": "Пропустить и оставить как черновик",
  "start_from_scratch_description": "Разработайте полностью новый опрос с вашими собственными вопросами",
  "start_from_scratch_title": "Создать индивидуальный опрос",
  "start_review": "Начать ревью",
  "start_share_with": "Поделиться с {name}",
  "stop_sharing_with": "Прекратить делиться отзывами с {name}",
  "use_ai_description": "Автоматически создавать выводы из отзывов",
  "use_ai_title": "Использовать ИИ для анализа ответов",
  "unsolicited": "По своей инициативе",
  "who_to_review": "Кого нужно оценить?",
  "x_axis": "Горизонтальная ось",
  "y_axis": "Вертикальная ось",
  "you_been_invited_to_select_peers": "Вас пригласили выбрать коллег, которые вас оценят",
  "~": "~"
}
